<template>
  <v-dialog
    v-model="dialog"
    width="500px">
    <div class="dialog-container">
      <h2>New Refer Request</h2>
      <div class="form-item">
        <span>Client Name</span>
        <v-input v-model="formData.name" />
      </div>
      <div class="form-item">
        <span>Client Contact Number</span>
        <v-input
          v-model="formData.phone"
          type="number" />
      </div>
      <div class="form-item">
        <span>Product Type</span>
        <v-select
          v-model="formData.product_id"
          :list="insuranceType" />
      </div>
      <div class="form-item">
        <span>Your Nickname</span>
        <v-input
          v-model="formData.nick_name"
          uppercase />
      </div>
      <div class="form-item">
        <span>Remark</span>
        <v-input
          v-model="formData.remark"
          type="textarea"
          :rows="4" />
      </div>
      <div class="form-item">
        <span>Supporting Documents</span>
        <file-container
          v-for="(item, index) in formData.other_file"
          :key="index"
          :fileData="item"
          :otherData="{
            index
          }" 
          :edit="true"
          titleName= "Supporting Documents"
          @delete="handlerDeleteFile"
          @uploadSuccess="handlerUploadSuccess"
        />
        <v-upload
          @uploadSuccess="handlerUploadSuccess" />
      </div>
      <div class="dialog-footer">

        <v-button @click="dialog = false">Cancel</v-button>

        <v-button
          type="success"
          @click="handlerSave">Save</v-button>

      </div>
    </div>
  </v-dialog>
</template>
<script>
import MixinOptions from '@/mixins/options'
import { addReferralRequest } from '@/api/request'
export default {
  name: 'NewRequest',
  mixins: [MixinOptions],
  props: {
    userId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      dialog: false,
      formData: {
        name: '',
        phone: '',
        product_id: '',
        nick_name: '',
        remark: '',
        other_file: []
      }
    }
  },
  computed: {
    insuranceType() {
      return this.globalOptions.insurance_type.filter(item => item.id !== 0)
    }
  },
  methods: {
    initForm() {
      this.formData = {
        name: '',
        phone: '',
        product_id: '',
        nick_name: '',
        remark: '',
        other_file: []
      }
    },
    changeDialog() {
      this.dialog = !this.dialog
    },
    handlerSave() {
      this.network().addReferralRequest()
    },
    handlerDeleteFile(otherData) {
      const { index } = otherData
      this.formData.other_file.splice(index, 1)
    },
    handlerUploadSuccess({ data, otherData }) {
      const { index = -1 } = otherData
      if(index == -1) {
        this.formData.other_file.push(data)
      }
      else {
        this.$set(this.formData.other_file, index, data)
      }
    },
    network() {
      return {
        addReferralRequest: async () => {
          const { data } = await addReferralRequest({
            ...this.formData,
            customer_id: this.userId
          })
          this.$emit('update')
          this.initForm()
          this.dialog = false
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
 .dialog-container {
    padding: 15px;
    .el-checkbox {
      margin: 10px 0;
    }
    p {
      padding-bottom: 15px;
    }
    .dialog-footer {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin-top: 10px;
    }
  }
</style>